import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { permissionQueries } from '@/services/auth/permissions.queries';

export function usePermission(roleId: string, enabled: boolean) {
  const { data, isFetching, error } = useQuery(permissionQueries.permissions(roleId, enabled));
  return { data: data?.data, isFetching, error };
}
